import config from "./config";
var axios = config();

import httpConfig from "./config";

export default {
  // get
  async getUser(cb) {
    // run axios setup
    let http = httpConfig();

    // Get the current user from the backend
    await http
      .get("/api/Users/GetUserRoles")
      .then(function(response) {
        let userObject = response.data;

        // Parse backend information into a user object
        let user = {
          id: "",
          userId: userObject.asuriteId,
          userRoles: [],
          userSupOrgs: [],
          isImpersonating: userObject.isImpersonating,
          trueUser: userObject.trueUser
            ? userObject.trueUser
            : userObject.asuriteId,
          firstName: userObject.firstName,
          lastName: userObject.lastName,
          fullName: userObject.firstName + " " + userObject.lastName,
          xsrftoken: userObject.xsrftoken
        };

        // Iterate through received roles and add their names to the user's userRoles array
        for (var index in userObject.roles) {
          user.userRoles.push(userObject.roles[index].name);
        }

        user.userSupOrgs = userObject.userSupOrgs;

        cb(user);
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  impersonate(asuriteId) {
    return axios.get("/Impersonation/" + asuriteId);
  },

  stopImpersonation() {
    return axios.get("/StopImpersonation");
  },

  // post
  logOff() {
    return axios.post("/Home/LogOff");
  },

  findLDAP(asurite) {
    return axios.get("/api/users/findldap?search=" + asurite);
  }
};
